import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createSlots as _createSlots, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { style: {"position":"absolute","right":"0","top":"0"} }
const _hoisted_2 = { class: "pa-1" }
const _hoisted_3 = { class: "d-block text-capitalize" }
const _hoisted_4 = {
  key: 0,
  class: "text-error pl-4"
}
const _hoisted_5 = { class: "label font-weight-bold" }
const _hoisted_6 = { class: "label font-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_etc_snackbar = _resolveComponent("etc-snackbar")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: $setup.valid.couponOptions,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.valid.couponOptions) = $event)),
    ref: "form",
    "lazy-validation": "",
    onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_etc_snackbar, {
            isOpen: $setup.error,
            color: "red-darken-2",
            message: "SVP corrigez les erreurs"
          }, null, 8, ["isOpen"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_checkbox, {
              modelValue: $setup.selectedCoupons,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedCoupons) = $event)),
              color: "red",
              "hide-details": "",
              value: $props.item
            }, null, 8, ["modelValue", "value"])
          ]),
          _createVNode(_component_v_col, {
            cols: "12",
            class: "flex-wrap"
          }, {
            default: _withCtx(() => [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "d-flex align-center" }, [
                _createElementVNode("label", { class: "label font-weight-bold" }, "Type")
              ], -1)),
              _createVNode(_component_v_btn_toggle, {
                tile: "",
                color: "deep-purple accent-3",
                class: "d-flex flex-wrap coupon-type",
                modelValue: $setup.couponTypeId,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => (($setup.couponTypeId) = $event)),
                  _cache[3] || (_cache[3] = ($event: any) => ($setup.validateOptions('couponTypeId', $setup.couponTypeId)))
                ]
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.types, (typeDef, index) => {
                    return (_openBlock(), _createBlock(_component_v_btn, {
                      key: index,
                      value: typeDef.id,
                      modelValue: $setup.couponTypeId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.couponTypeId) = $event)),
                      class: "coupon-type-btn",
                      onClick: $setup.selectedType,
                      block: _ctx.$vuetify.display.mobile
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("strong", null, _toDisplayString(typeDef.code), 1),
                          _createElementVNode("span", _hoisted_3, _toDisplayString(typeDef.label), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value", "modelValue", "onClick", "block"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (!$setup.couponTypeId && $props.item.state !== 'rejected')
                ? (_openBlock(), _createElementBlock("small", _hoisted_4, " Type de coupon est requis "))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("label", _hoisted_5, _toDisplayString(!!$setup.currentType && $setup.currentType.code == 'ECR' ? 'FACTURE #' : '# Coupon'), 1),
                      _createVNode(_component_v_text_field, {
                        modelValue: $setup.couponNumber,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.couponNumber) = $event)),
                        variant: "outlined",
                        disabled: $props.isDisabled,
                        "hide-details": $props.item.state === 'rejected' ? true : 'auto',
                        density: "compact",
                        rules: $setup.rules.coupon.couponNumber,
                        onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.validateOptions('couponNumber', $setup.couponNumber)))
                      }, null, 8, ["modelValue", "disabled", "hide-details", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("label", _hoisted_6, _toDisplayString(!!$setup.currentType && $setup.currentType.code == 'ECR' ? 'TERM #' : '# Compte'), 1),
                      _createVNode(_component_v_text_field, {
                        modelValue: $setup.accountNumber,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.accountNumber) = $event)),
                        variant: "outlined",
                        "hide-details": $props.item.state === 'rejected' ? true : 'auto',
                        density: "compact",
                        rules: $setup.rules.coupon.accountNumber,
                        disabled: $props.isDisabled,
                        onBlur: $setup.checkAccountNumber
                      }, _createSlots({ _: 2 }, [
                        ($setup.currentType?.code !== 'CCC' && $setup.currentType?.code !== 'ECR')
                          ? {
                              name: "append-inner",
                              fn: _withCtx(() => [
                                ($setup.couponNumberLoading)
                                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                      key: 0,
                                      size: 20,
                                      indeterminate: "",
                                      color: "green"
                                    }))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      ($setup.isActive && $setup.isChange)
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            style: {"color":"green"}
                                          }, {
                                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                              _createTextVNode(" mdi-check-circle ", -1)
                                            ]))]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (!$setup.isActive && $setup.isChange)
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 1,
                                            style: {"color":"red"}
                                          }, {
                                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                              _createTextVNode(" mdi-alert-circle ", -1)
                                            ]))]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ], 64)),
                                ($setup.isActive && $setup.isChange)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 2,
                                      activator: "parent",
                                      location: "bottom"
                                    }, {
                                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                        _createTextVNode(" Le numéro de compte est actif ", -1)
                                      ]))]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["modelValue", "hide-details", "rules", "disabled", "onBlur"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _cache[15] || (_cache[15] = _createElementVNode("label", { class: "label font-weight-bold" }, "Montant", -1)),
                      _createVNode(_component_currency_input, {
                        "style-options": {
                variant: 'outlined',
                hideDetails: $props.item.state === 'rejected' ? true : 'auto',
                density: 'compact',
                disabled: $props.isDisabled,
              },
                        options: { currency: 'CAD', locale: 'fr-CA', autoDecimalDigits: true },
                        modelValue: $setup.amount,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.amount) = $event)),
                        modelModifiers: { number: true },
                        rules: $setup.rules.coupon.amount,
                        onBlur: _cache[8] || (_cache[8] = ($event: any) => ($setup.validateOptions('amount', $setup.amount)))
                      }, null, 8, ["style-options", "modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}